import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoharihareshwartaxifare() {



const cardData = {
  keyword: "Pune to Harihareshwar Taxi Fare",
  heading: "Lotus Cab: Pune to Harihareshwar Taxi Fare",

  headingDescription:
    "Lotus Cab offers affordable and transparent Pune to Harihareshwar taxi fare for smooth coastal travel from Pune to the beautiful Konkan region. Harihareshwar, known for its serene beach and the famous Harihareshwar Temple, is a popular weekend and holiday destination located approximately 170–190 km from Pune. Whether you need a one-way cab, round-trip taxi, same-day return trip, or multi-day coastal travel package, we provide flexible booking options with clear per kilometer pricing. Our AC sedans and SUVs are well-maintained, sanitized, and driven by experienced chauffeurs familiar with Konkan ghat roads and coastal highways. Ideal for family trips, temple visits, corporate outings, and weekend beach vacations, Lotus Cab ensures safe driving, comfortable seating, and timely pickup across Pune. With easy online booking and 24/7 customer support, we make your Pune to Harihareshwar journey affordable, reliable, and stress-free.",

  top: "Top Places to Visit in Harihareshwar with Lotus Cab",

  topPlaces: [
    {
      title: "Harihareshwar Temple",
      description:
        "Harihareshwar Temple is a sacred pilgrimage site dedicated to Lord Shiva and attracts devotees from across Maharashtra. Many travelers book Pune to Harihareshwar cab service for temple darshan and peaceful spiritual visits. The temple is located near the seashore, offering a calm and divine atmosphere. Lotus Cab provides comfortable round-trip taxi options with flexible waiting time for darshan."
    },
    {
      title: "Harihareshwar Beach",
      description:
        "Harihareshwar Beach is known for its clean shoreline and scenic sunset views. Families and couples prefer weekend trip taxi from Pune for a relaxing coastal getaway. AC sedan and SUV options ensure comfortable long-distance travel."
    },
    {
      title: "Kalbhairav Temple",
      description:
        "Kalbhairav Temple is an important spiritual stop before visiting the main Harihareshwar Temple. Devotees often include this in their same-day return cab itinerary."
    },
    {
      title: "Shrivardhan Beach",
      description:
        "Located nearby, Shrivardhan Beach is ideal for peaceful family outings and picnic trips. Spacious SUV cabs are suitable for group travel."
    },
    {
      title: "Diveagar Beach",
      description:
        "Diveagar Beach offers a serene coastal experience perfect for holiday trips. Round-trip taxi booking ensures relaxed sightseeing."
    },
    {
      title: "Bagmandla Ferry Point",
      description:
        "Bagmandla offers scenic ferry rides and coastal views. Chauffeur-driven cabs provide easy access to nearby attractions."
    },
    {
      title: "Bankot Fort",
      description:
        "A historic fort offering panoramic views of the coastline and Savitri River. Ideal for travelers interested in history and photography."
    },
    {
      title: "Konkan Coastal Drive",
      description:
        "The scenic Konkan route itself is a major highlight with lush greenery and sea views. Lotus Cab ensures safe ghat-road driving experience."
    }
  ],

  services: [
    {
      name: "Pune to Harihareshwar Taxi Fare",
      description:
        "Lotus Cab provides transparent Pune to Harihareshwar taxi fare with clear per kilometer pricing and no hidden charges. Our pricing structure includes sedan and SUV options based on travel requirements. Ideal for families, temple visits, weekend beach holidays, and corporate outings. Experienced drivers ensure safe ghat-road navigation. Flexible one-way, round-trip, and multi-day travel packages available."
    },
    {
      name: "Pune to Harihareshwar Cab Service",
      description:
        "Reliable AC cab service from Pune to Harihareshwar with well-maintained vehicles and professional chauffeurs. Comfortable seating and luggage support provided."
    },
    {
      name: "Pune to Harihareshwar One Way Cab",
      description:
        "Affordable one-way drop taxi service where you pay only for single-side distance. Transparent billing with no extra hidden charges."
    },
    {
      name: "Round Trip Taxi Pune to Harihareshwar",
      description:
        "Convenient round-trip packages with flexible return timing suitable for weekend beach and temple visits."
    },
    {
      name: "SUV Cab Pune to Harihareshwar",
      description:
        "Spacious SUV taxi option ideal for family groups and coastal travel with luggage."
    },
    {
      name: "Luxury Cab Pune to Harihareshwar",
      description:
        "Premium vehicle options for comfortable long-distance coastal travel experience."
    },
    {
      name: "Same Day Return Cab Pune to Harihareshwar",
      description:
        "Fast and convenient same-day return cab for short temple visits and quick coastal trips."
    },
    {
      name: "Online Taxi Booking Pune to Harihareshwar",
      description:
        "Easy online booking with instant confirmation and 24/7 customer assistance."
    }
  ],

  tableData: [
    ["Pune to Harihareshwar Taxi Fare", "Pune to Harihareshwar Cab Service"],
    ["Pune to Harihareshwar One Way Cab", "Round Trip Taxi Pune to Harihareshwar"],
    ["AC Taxi Fare Pune to Harihareshwar", "SUV Cab Pune to Harihareshwar"],
    ["Luxury Cab Pune to Harihareshwar", "Family Trip Taxi Pune to Harihareshwar"],
    ["Weekend Trip Cab Pune to Harihareshwar", "Corporate Outstation Cab Pune to Harihareshwar"],
    ["Per Km Taxi Rate Pune to Harihareshwar", "Online Taxi Booking Pune to Harihareshwar"],
    ["Best Cab Service Pune to Harihareshwar", "Affordable Taxi Pune to Harihareshwar"],
    ["Sedan Cab Pune to Harihareshwar", "Chauffeur Driven Cab Pune to Harihareshwar"],
    ["Same Day Return Cab Pune to Harihareshwar", "Outstation Taxi Pune to Harihareshwar"],
    ["Holiday Trip Taxi Pune to Harihareshwar", "Picnic Taxi Pune to Harihareshwar"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription:
        "Clear per kilometer taxi fare with no hidden charges ensures budget-friendly coastal travel."
    },
    {
      WhyChooseheading: "Experienced Konkan Route Drivers",
      WhyChoosedescription:
        "Professional chauffeurs experienced in ghat roads and coastal highways."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "Fully air-conditioned sedan and SUV options for relaxed long-distance travel."
    },
    {
      WhyChooseheading: "Flexible One-Way & Round Trip Options",
      WhyChoosedescription:
        "Choose travel package based on your itinerary and schedule."
    },
    {
      WhyChooseheading: "Ideal for Temple & Beach Trips",
      WhyChoosedescription:
        "Perfect cab service for pilgrimage, weekend holidays, and family vacations."
    },
    {
      WhyChooseheading: "Doorstep Pickup Across Pune",
      WhyChoosedescription:
        "Convenient pickup from home, hotel, or airport."
    },
    {
      WhyChooseheading: "Luxury & SUV Options Available",
      WhyChoosedescription:
        "Premium vehicle options for comfortable group and family travel."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock booking assistance and travel support."
    }
  ]
};

const faqData = [
  { question: "What is the distance from Pune to Harihareshwar?", answer: "Harihareshwar is approximately 170–190 km from Pune and takes around 5–6 hours by road." },
  { question: "Is one-way taxi available?", answer: "Yes, affordable one-way drop cab is available with transparent pricing." },
  { question: "Are SUV options available?", answer: "Yes, spacious SUV taxis are available for family and group travel." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return cab service is available for short trips." },
  { question: "Is fare calculated per km?", answer: "Yes, taxi fare is calculated on per kilometer basis with clear billing." },
  { question: "Is AC taxi provided?", answer: "Yes, fully air-conditioned vehicles are provided for comfort." },
  { question: "Is online booking available?", answer: "Yes, instant online booking with confirmation is available." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate outstation taxi packages are available." },
  { question: "Are drivers experienced in ghat roads?", answer: "Yes, trained drivers experienced in Konkan routes." },
  { question: "Is 24/7 support available?", answer: "Yes, customer assistance is available round the clock." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshpande",
    feedback:
      "Booked Pune to Harihareshwar taxi for family temple visit. Smooth ride, transparent fare, and very professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Weekend beach trip was comfortable and stress-free. SUV taxi was spacious and driver was experienced.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable outstation cab service with clear pricing and punctual pickup. Highly recommended.",
    rating: 5
  }
];
















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Harihareshwar Taxi Fare",
  "image": "https://lotuscab.com/assets/images/pune-to-harihareshwar-taxi.jpg", 
  "description": "Lotus Cab provides taxi services from Pune to Harihareshwar with transparent fares for one-way, round-trip, family trips, weekend getaways, corporate travel, and holiday outings. Choose from AC, SUV, luxury, and sedan cabs with chauffeur service, affordable per km rates, and easy online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-harihareshwar-taxi-fare"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Harihareshwar Taxi Fare | Lotus Cab</title>
  <meta 
    name="description" 
    content="Check Pune to Harihareshwar taxi fare with Lotus Cab. One-way, round-trip, family, weekend & corporate trips. AC, SUV & luxury cabs with chauffeur service. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Harihareshwar Taxi Fare, Pune to Harihareshwar Cab Service, Pune to Harihareshwar One Way Cab, Round Trip Taxi Pune to Harihareshwar, AC Taxi Fare Pune to Harihareshwar, SUV Cab Pune to Harihareshwar, Luxury Cab Pune to Harihareshwar, Family Trip Taxi Pune to Harihareshwar, Weekend Trip Cab Pune to Harihareshwar, Corporate Outstation Cab Pune to Harihareshwar, Per Km Taxi Rate Pune to Harihareshwar, Online Taxi Booking Pune to Harihareshwar, Best Cab Service Pune to Harihareshwar, Affordable Taxi Pune to Harihareshwar, Sedan Cab Pune to Harihareshwar, Chauffeur Driven Cab Pune to Harihareshwar, Same Day Return Cab Pune to Harihareshwar, Outstation Taxi Pune to Harihareshwar, Holiday Trip Taxi Pune to Harihareshwar, Picnic Taxi Pune to Harihareshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoharihareshwartaxifare;